var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.04001C10.56 3.04001 3.04004 10.56 3.04004 20C3.04004 29.44 10.56 36.96 20 36.96C29.44 36.96 36.96 29.44 36.96 20C36.96 10.56 29.44 3.04001 20 3.04001ZM32.16 20C32.16 22.56 31.36 24.8 30.08 26.72L13.28 9.76001C15.2 8.48001 17.44 7.84001 20 7.84001C26.72 7.84001 32.16 13.28 32.16 20ZM7.84004 20C7.84004 17.44 8.64004 15.2 9.92004 13.28L26.88 30.24C24.96 31.52 22.56 32.32 20.16 32.32C13.28 32.16 7.84004 26.72 7.84004 20Z",
    fill: "#BD2C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedArea);
export default __webpack_public_path__ + "static/media/closed-area.2f1e8fdf043c49b7c3b05571d8ba94d6.svg";
export { ForwardRef as ReactComponent };